module.exports = __webpack_public_path__ + "static/media/bts_lalela_170710_021_small.2a7e9691.jpg";